module.exports = __webpack_public_path__ + "static/media/404-error.946c7347.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/404-error.mp4
// module id = 847
// module chunks = 0